/* eslint-disable no-undef */
import { VFC, useEffect, useMemo } from 'react';

export interface FloorplanMarker {
  id: string;
  title?: string;
  lat: number;
  lng: number;
}

interface MarkerProps extends google.maps.MarkerOptions {
  id: string;
  onDragEnd?: (updatedMarker: FloorplanMarker) => void;
}

export const Marker: VFC<MarkerProps> = ({ id, onDragEnd, ...restOptions }) => {
  const marker = useMemo(() => new google.maps.Marker(), []);

  useEffect(() => () => marker.setMap(null), [marker]);

  useEffect(() => {
    const dragListener = marker.addListener('dragend', () => {
      const position = marker?.getPosition();
      const lat = position?.lat();
      const lng = position?.lng();
      if (lat !== undefined && lng !== undefined) {
        onDragEnd?.({ id, lat, lng });
      }
    });

    return () => dragListener.remove();
  }, [marker, id, onDragEnd]);

  useEffect(() => {
    const { position, ...rest } = restOptions;

    marker.setOptions({
      ...(typeof position?.lat === 'number' && typeof position?.lng === 'number' ? { position } : {}),

      ...rest,
    });
  }, [marker, restOptions]);

  return null;
};
